<section class="mod-page case-page" data-module="cases">
  <header class="page-header">
    <div>
      <p class="eyebrow">Cases</p>
      <h1>Case management</h1>
    </div>
    <p class="case-count">{{ list().length }} open</p>
  </header>

  @if (message()) {
    <p class="toast">{{ message() }}</p>
  }

  @if (list().length) {
    <nav class="case-tabs" aria-label="Case list">
      @for (item of list(); track item.id) {
        <button
          type="button"
          class="case-tab"
          [class.is-active]="selected()?.id === item.id"
          (click)="selectedId.set(item.id)"
        >
          {{ item.caseNo }}
          <span [class]="'case-pill ' + statusTone(item.status)">{{ item.status }}</span>
        </button>
      }
    </nav>
  }

  @if (selected(); as item) {
    <div class="case-layout">
      <section class="case-panel case-main">
        <div class="case-title-row">
          <h2>{{ item.subject }}</h2>
          <span [class]="'case-pill ' + statusTone(item.status)">{{ item.status }}</span>
        </div>

        <div class="case-facts">
          <div class="fact fact-id">
            <span>Tracking ID</span>
            <strong>{{ item.trackingId }}</strong>
          </div>
          <div class="fact fact-dept">
            <span>Department</span>
            <strong>{{ item.department }}</strong>
          </div>
          <div class="fact fact-officer">
            <span>Assigned</span>
            <strong>{{ item.officer }}</strong>
          </div>
          <div class="fact fact-date">
            <span>Opened</span>
            <strong>{{ item.openedAt | date: 'd MMM y' }}</strong>
          </div>
          @if (item.investigationDueAt) {
            <div class="fact fact-due" [class.is-urgent]="dueUrgent(item.investigationDueAt)">
              <span>Inspection due</span>
              <strong>{{ item.investigationDueAt | date: 'd MMM y' }}</strong>
              <em>{{ dueLabel(item.investigationDueAt) }}</em>
            </div>
          }
        </div>

        <h3 class="case-sec">Timeline</h3>
        <ul class="case-timeline">
          <li>
            <span class="dot d-open"></span>
            <div>
              <strong>Case opened</strong>
              <span>{{ item.openedAt | date: 'd MMM y, HH:mm' }}</span>
            </div>
          </li>
          <li>
            <span class="dot d-assign"></span>
            <div>
              <strong>Assigned</strong>
              <span>{{ item.officer }}</span>
            </div>
          </li>
          @if (item.investigationDueAt) {
            <li>
              <span class="dot d-due"></span>
              <div>
                <strong>Investigation deadline</strong>
                <span>{{ item.investigationDueAt | date: 'd MMM y' }} · {{ dueLabel(item.investigationDueAt) }}</span>
              </div>
            </li>
          }
          <li>
            <span class="dot d-status"></span>
            <div>
              <strong>Status</strong>
              <span>{{ item.status }}</span>
            </div>
          </li>
        </ul>
      </section>

      <aside class="case-side">
        <section class="case-panel">
          <h3 class="case-sec">Investigation</h3>

          @if (item.notes) {
            <div class="case-notes-existing">{{ item.notes }}</div>
          } @else {
            <p class="case-empty">No notes yet.</p>
          }

          <label class="case-note-label">
            Add note
            <textarea
              class="field"
              rows="4"
              [ngModel]="note()"
              (ngModelChange)="note.set($event)"
              placeholder="Findings, evidence, recommendation…"
            ></textarea>
          </label>

          <div class="case-actions">
            <button type="button" class="btn" [disabled]="busy() || !note().trim()" (click)="addNote()">
              Add Note
            </button>
            @if (canSubmitReport()) {
              <button type="button" class="btn primary" [disabled]="busy()" (click)="submitReport()">
                {{ busy() ? 'Submitting…' : 'Submit Report' }}
              </button>
            }
          </div>
        </section>

        <section class="case-panel">
          <div class="case-attach-head">
            <h3 class="case-sec">Attachments</h3>
            <label class="case-upload-btn" [class.is-busy]="uploadBusy()">
              {{ uploadBusy() ? 'Uploading…' : 'Upload' }}
              <input
                type="file"
                accept=".pdf,.doc,.docx,image/*,.png,.jpg,.jpeg,.webp,.gif"
                [disabled]="uploadBusy()"
                (change)="onFileSelected($event)"
              />
            </label>
          </div>
          <p class="case-upload-hint">PDF, Word, or image — max 5 MB</p>
          <ul class="case-files">
            @for (file of attachments(); track file.id) {
              <li>
                <span [class]="'file-icon ' + fileKindClass(file.kind)">
                  {{ file.kind === 'PDF' ? 'PDF' : file.kind === 'DOC' ? 'DOC' : 'IMG' }}
                </span>
                <div class="file-meta">
                  <span class="file-name">{{ file.fileName }}</span>
                  @if (formatSize(file.sizeBytes); as size) {
                    <span class="file-size">{{ size }}</span>
                  }
                </div>
              </li>
            } @empty {
              <li class="case-files-empty">No attachments yet. Upload evidence for this case.</li>
            }
          </ul>
        </section>
      </aside>
    </div>
  } @else {
    <section class="case-panel case-empty-state">
      <p class="muted">No cases available for your desk.</p>
    </section>
  }
</section>
